import _ from "lodash";
const View = ({ color = "#F7EEDF", ...props }: any) => {
  return (
    <svg {...props} width="49" height="48" viewBox="0 0 49 48" fill="none">
      <g>
        <path
          d="M48.5 24C48.5 37.2551 37.7551 48 24.5 48C11.2449 48 0.5 37.2551 0.5 24C0.5 10.7449 11.2449 0 24.5 0C37.7551 0 48.5 10.7449 48.5 24Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.5 16C34.8076 16 35.0989 16.0694 35.3592 16.1935L24.5 25.1364L13.6408 16.1935C13.9011 16.0694 14.1924 16 14.5 16H34.5ZM12.7098 30.8479C12.7033 30.854 12.697 30.8601 12.6908 30.8664C12.5684 30.6075 12.5 30.3182 12.5 30.0128V18C12.5 17.6913 12.57 17.3988 12.6949 17.1378C12.71 17.1529 12.726 17.1674 12.7429 17.1813L20.4696 23.5445L12.7098 30.8479ZM14.5 32.0128C14.1878 32.0128 13.8923 31.9413 13.629 31.8137L21.5072 24.399L24.0762 26.5146C24.3224 26.7173 24.6776 26.7173 24.9238 26.5146L27.4928 24.399L35.371 31.8137C35.1077 31.9413 34.8122 32.0128 34.5 32.0128H14.5ZM36.3092 30.8664C36.4316 30.6075 36.5 30.3182 36.5 30.0128V18C36.5 17.6913 36.43 17.3988 36.3051 17.1378C36.29 17.1529 36.274 17.1674 36.2571 17.1813L28.5304 23.5445L36.2902 30.8479C36.2967 30.854 36.303 30.8601 36.3092 30.8664Z"
          fill="black"
        />
      </g>
    </svg>
  );
};
export default View;
